import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { PropsWithChildren } from "react";
import Cookies from "universal-cookie";

const TokenContext = React.createContext<{ token: null | string; setToken: (token: string | null) => void }>({
  token: null,
  setToken: () => {},
});

export function useToken() {
  return useContext(TokenContext);
}

function set_cookies(token: string | null, cookies: Cookies) {
  if (token === null) {
    cookies.remove("lf_merchant_token", { path: "/", domain: ".l192.com" });
    cookies.remove("lf_merchant_token", { path: window.location.pathname, domain: ".l192.com" });
    cookies.remove("lf_merchant_token", { path: "/" });
    cookies.remove("lf_merchant_token", { path: window.location.pathname });
  }
}

export function TokenProvider(props: PropsWithChildren<unknown>) {
  const cookies = new Cookies();
  const pathname = useMemo(() => window.location.pathname, []);

  const [token, setInternalToken] = useState<string | null>(localStorage.getItem("token"));

  const setToken = useCallback(
    (token: string | null) => {
      setInternalToken(token);
      if (token === null) {
        set_cookies(token, cookies);
        localStorage.removeItem("token");
      } else {
        localStorage.setItem("token", token);
      }
    },
    [setInternalToken, cookies],
  );

  useEffect(() => {
    const token_cookies = cookies.get("lf_merchant_token");

    if (token_cookies) {
      setToken(token_cookies);
    }
  }, [cookies, setToken]);

  useEffect(() => {
    if (["/login", "/signup"].includes(pathname)) {
      setToken(null);
    }
  }, [pathname, setToken]);

  return <TokenContext.Provider value={{ token, setToken }}>{props.children}</TokenContext.Provider>;
}
